<template>
<div class="chapter">
<div class="inner_page">
<h1>PREFACE</h1>
<div class="img"><img alt="" src="images/p6.jpg"/></div>
<p class="noindent top1">We live in a time of crushing change and unrest. The world is at a turning point, and we with it. Our individual lives and journeys are all interconnected. It is a moment in time to stop and listen to the voices within ourselves and what they are saying about our individual roles at this time. What can we do to ensure the health of our planet and civilization, as we know it? What will we teach our children, who will they be, and what are we leaving them?</p>
<p class="indent">When something so powerful and important resonates within, it is our responsibility as humans to follow that voice and calling. This is one such story.</p>
<p class="indent">My love and passion for our wild horses have led me on a journey of self-empowerment, realization, and rewilding. It is through this journey that I <span class="u">am</span> learning who I am and who I can be. This journey awaits us all if we choose to open our hearts to hear our innate reason and who we want to be while discovering who we really are.</p>
<p class="indent">I hope that by sharing my journey with you that you will be open to seeing your calling. There are no rules, and there are no prerequisites to finding your path. You just have to ask to be shown; that is your first step.</p>
<p class="indent">So, join me on my rewilding journey to save our wild horses. It’s been a crazy ride, and it’s not over!</p>
<p class="indent">As you read these pages, you will see that I refer repeatedly to America’s indigenous people. Many views exist on the correct terminology, and not wishing to offend anybody; I want to clarify why, at times, I use American Indian in this context. One of the principal characters on this journey whom you are about to meet, Moses Brings Plenty, A Lakota Sioux, calls himself an Indian and considers ‘American’ redundant. American is inferred. Others find this term offensive and prefer Native American. Whatever your view, when I refer to the original inhabitants of this land, I only do so with the deepest respect.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// p5.vue?4696ce26